import PropTypes from 'prop-types'

const fieldPropTypes = {
  // These are values passed from the formik <Field> component to the underlying input element
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }).isRequired,
  // These are values passed from the formik <Form> component to the underlying input element
  form: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
  }).isRequired,
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  classes: PropTypes.object,
  showErrorBeforeTouched: PropTypes.bool,
}

export default fieldPropTypes
